import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

function daysLeft(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  const diff = (d.getTime() - Date.now()) / (1000 * 60 * 60 * 24);
  return Math.max(0, Math.ceil(diff));
}

function fmt(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

export default function PremiumStatus() {
  const { user } = useAuth();
  if (!user) return null;
  const isOwner = user.role === "owner";
  const isPremium = !!user.is_premium;
  const left = daysLeft(user.premium_until);

  if (isOwner) {
    return (
      <div
        data-testid="premium-status"
        className="bg-[#0F0F0F] border border-[#D4AF37]/40 p-5 mt-6"
      >
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] font-bold mb-1 inline-flex items-center gap-1.5">
          <span>👑</span> Owner — Lifetime Access
        </div>
        <p className="text-sm text-neutral-400">
          Every Premium feature is unlocked permanently for the Phoenix herself.
        </p>
      </div>
    );
  }

  if (!isPremium) {
    return (
      <div
        data-testid="premium-status"
        className="bg-gradient-to-br from-[#4C1D95]/30 via-[#0F0F0F] to-[#0F0F0F] border border-purple-700/40 p-6 mt-6"
      >
        <div className="text-[10px] uppercase tracking-[0.3em] text-purple-400 font-bold mb-1">
          You're on the Free path
        </div>
        <h2 className="font-display text-2xl text-white mb-2">
          Unlock the <span className="text-[#D4AF37]">Inner Circle.</span>
        </h2>
        <p className="text-sm text-neutral-400 mb-4">
          Try Premium for 7 days at <span className="text-[#D4AF37] font-bold">$0.99</span>,
          or jump straight in monthly / yearly. Every plan unlocks AI Coach unlimited,
          advanced trackers, and a +1000 Phoenix Token bonus.
        </p>
        <Link
          to="/plans"
          data-testid="premium-status-upgrade"
          className="inline-block bg-[#D4AF37] hover:bg-[#F1C84B] text-[#0A0A0A] font-bold uppercase tracking-[0.2em] text-xs px-5 py-3 transition-all"
        >
          See Plans →
        </Link>
      </div>
    );
  }

  return (
    <div
      data-testid="premium-status"
      className="bg-[#0F0F0F] border-2 border-[#D4AF37] p-6 mt-6"
    >
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] font-bold mb-1 inline-flex items-center gap-1.5">
            <span>🐦‍🔥</span> Premium · Active
          </div>
          <h2 className="font-display text-2xl text-white">
            Inner Circle Member.
          </h2>
          {user.premium_until ? (
            <p className="text-sm text-neutral-400 mt-1">
              Access through <span className="text-white font-bold">{fmt(user.premium_until)}</span>
              {left !== null && (
                <span className="ml-1 text-[#D4AF37] font-bold">
                  · {left} day{left === 1 ? "" : "s"} left
                </span>
              )}
            </p>
          ) : (
            <p className="text-sm text-neutral-400 mt-1">Active.</p>
          )}
        </div>
        <Link
          to="/plans"
          data-testid="premium-status-extend"
          className="bg-white hover:bg-neutral-200 text-[#0A0A0A] font-bold uppercase tracking-[0.2em] text-xs px-4 py-3 transition-all"
        >
          Extend / Renew
        </Link>
      </div>
      {left !== null && left <= 7 && (
        <p className="text-xs text-red-400 mt-3 uppercase tracking-widest font-bold">
          ⚡ Less than a week left — renew now to keep your fire alive.
        </p>
      )}
    </div>
  );
}
